import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-004c9272"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "incompatible-browser-service" }
const _hoisted_2 = { class: "incompatible-browser-service--message-container" }
const _hoisted_3 = { class: "incompatible-browser-service--description" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-x-small incompatible-browser-service--icon" }, null, -1))

import { IncrediButton } from 'incredi-ui';
import { useIncompatibleBrowserService } from './IncompatibleBrowserService.helpers';
import IbxScopedCss from '../../components/IbxScopedCss/IbxScopedCss.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'IncompatibleBrowserService',
  setup(__props) {

const { incompatibleDescription, isIncompatibleBrowser } = useIncompatibleBrowserService();

return (_ctx: any,_cache: any) => {
  return (_unref(isIncompatibleBrowser))
    ? (_openBlock(), _createBlock(IbxScopedCss, {
        key: 0,
        class: "z-[10001]"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(incompatibleDescription)), 1),
              _createVNode(_unref(IncrediButton), {
                fab: "",
                design: "ghost-grey",
                class: "w-[40px] h-[40px]",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (isIncompatibleBrowser.value = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})